<style lang="postcss">
	.label {
		align-self: flex-start;
		font-size: 1rem;
		line-height: 1.5;
	}
</style>

<script lang="ts">
	export let html: string;
</script>

<div class="label">
	{@html html.includes("<p") ? html : `<p>${html}</p>`}
</div>
